import React from 'react'
import { VertRate, VertTypography } from "@vertem-core/vertice-ds";
import { ratePointsMask } from 'Utils/commons/mask';

const ProductDetailRate = ({ rate }) => {
    return (
        <>
            <div className="product-reviews">
                <VertTypography.Paragraph>
                    Avaliações do produto
                </VertTypography.Paragraph>

                <VertRate
                    allowHalf
                    disabled
                    size="small"
                    template="marketplace"
                    value={rate.average}
                />

                <VertTypography.Paragraph>
                    {rate.average && ratePointsMask(rate.average)}
                </VertTypography.Paragraph>
            </div>
        </>
    )
}

export default ProductDetailRate
